/**
 * The sign beside the versions' heading while they're written, without words
 * (results-panel.css): three words of different lengths kept in the air, juggled along one loop.
 * Only to look at: the panel says what's going on, out of sight.
 */
export function RewriteSign() {
  return (
    <span className="word-juggle" aria-hidden="true">
      <i />
      <i />
      <i />
    </span>
  );
}
